export default {
    VALOR_FORA_MARGEM_ESPERADA: 'VALOR_FORA_MARGEM_ESPERADA'
}
